import MODEL_NAME from 'typings/models/_model.enum';
import defaultState from 'storage/defaultState';
import SliceFactory from './SliceFactory';

const initialState: OrderViewState = {
  ...defaultState,
  orderView: null,
  orderViewAll: [],
  orderViewList: [],
  orderViewAllAreLoading: false,
  orderViewIsLoading: false,
  tableViewList: [],
  tableView: null,
};

const reducers = SliceFactory.createModelReducers<MODEL_NAME.orderView, OrderView, OrderViewState>(
  MODEL_NAME.orderView,
  initialState
);

reducers.setList = function (state, action) {
  const { data, pagination, requestProps } = action.payload;
  state.isListOutdated = false;
  state.error = null;
  state.pagination = pagination;
  state.lastListRequestFilter = requestProps?.lastListRequestFilter;

  const tableViews: OrderView[] = [];
  const filterViews: OrderView[] = [];

  // Отличие от дефолтного метода здесь
  data.forEach((view) => {
    if (view.viewVisibility?.visibleInCardView === false) {
      tableViews.push(view);
    } else {
      filterViews.push(view);
    }
  });
  state.tableViewList = tableViews;
  state.listOfEntities = filterViews;
  state.orderViewList = filterViews;
};

reducers.setTableView = function (state, action) {
  state.tableView = action.payload;
}

const orderViewSlice = SliceFactory.createModelSlice<MODEL_NAME.orderView, OrderView, OrderViewState>(
  MODEL_NAME.orderView,
  initialState,
  reducers
);

export default orderViewSlice;
